import { render, staticRenderFns } from "./paymentOkPage.vue?vue&type=template&id=8e38069c&"
import script from "./paymentOkPage.vue?vue&type=script&lang=ts&"
export * from "./paymentOkPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../wellness/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports